import type { ComponentPodcastPodcastPlatformLink } from '@edwin-group/people-graphql';

interface PodcastPlatformProps {
  item: ComponentPodcastPodcastPlatformLink;
}

export const PodcastPlatform = ({ item }: PodcastPlatformProps) => {
  const label = item.platform?.name ?? '';
  const href = item.url ?? '';
  const iconUrl = item.platform?.icon?.url ?? '';
  const iconAlt = item.platform?.icon?.alternativeText ?? label;

  if (!label || !href) return null;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className="flex items-center gap-[4px] font-haffer text-sh-12-18 font-normal text-dark-grey">
      {iconUrl && <img src={iconUrl} alt={iconAlt} className="h-6 w-6 shrink-0" />}
      <span>{label}</span>
    </a>
  );
};
